var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphDiet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 15)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#3A9B2E",
    cx: 32,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78D36D",
    cx: 19,
    cy: 17,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47AF3A",
    cx: 41,
    cy: 24,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 49h22v3a3 3 0 0 1-3 3H22a3 3 0 0 1-3-3v-3z",
    fill: "#BDBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.995 21h50.01a3.6 3.6 0 0 1 3.416 4.738l-3.863 11.587A20 20 0 0 1 35.585 51h-11.17A20 20 0 0 1 5.442 37.325L1.579 25.738A3.6 3.6 0 0 1 4.995 21z",
    fill: "#D8D8D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphDiet);
export default __webpack_public_path__ + "static/media/icons_graph_diet.d54eae9b6d40397a415775fcc6e38ae7.svg";
export { ForwardRef as ReactComponent };